import { useReduxDispatch } from "@/store/useReduxDispatch"
import "./WishRegs.scss"
import { registerWishThunk } from "@/thunks/wishThunks"
import cn from "classnames"
import { getIsAdmin } from "@/services/authService"
import { settingsSelectors } from "@/slices/settingsSlice"
import { useSelector } from "react-redux"

interface IWishRegsProps {
  wish: IWishDto
}

export const WishRegs = ({ wish }: IWishRegsProps): JSX.Element => {
  const dispatch = useReduxDispatch()
  const adminShowRegistrations = useSelector(settingsSelectors.adminShowRegistrations)

  const hideResults = getIsAdmin() && !adminShowRegistrations
  const canAdd = hideResults ? true : wish.qty > wish.regs
  const canRemove = hideResults ? false : wish.myRegs > 0

  return (
    <div className="wish-regs">
      <div className="wish-regs__button-container">
        {canRemove && (
          <div
            className={cn(
              "wish-regs__button wish-regs__button--remove",
              !canRemove && "wish-regs__button--disabled"
            )}
            onClick={async () => {
              if (!canRemove) {
                return
              }
              await dispatch(registerWishThunk(wish.id, -1))
            }}
          >
            -
          </div>
        )}
        <div
          className={cn(
            "wish-regs__button wish-regs__button--add",
            !canAdd && "wish-regs__button--disabled"
          )}
          onClick={async () => {
            if (!canAdd || hideResults) {
              return
            }
            await dispatch(registerWishThunk(wish.id, 1))
          }}
        >
          +
        </div>
      </div>
      <div className="wish-regs__text-container">
        {wish.myRegs > 0 ? `(dine køb: ${wish.myRegs}) ` : " "}
        {hideResults ? "?" : wish.regs}
        {"/"} {wish.qty}
      </div>
    </div>
  )
}
